import { z } from "zod";
export const requestOtpSchema = z.object({
    email: z.email({ message: "Email is required" }).toLowerCase().trim(),
});
